import React from 'react';
import ProtectedRoute from "./ProtectedRoute";


import im1 from './images/im1.png';
import im2 from './images/im2.png';
import im3 from './images/im3.png';
import im4 from './images/im4.png';
import im5 from './images/im5.png';
import im6 from './images/im6.png';
import im7 from './images/im7.png';
import im8 from './images/im8.png';
import im9 from './images/im9.png';
import im10 from './images/im10.png';
import im11 from './images/im11.png';
import im12 from './images/im12.png';


import ImageGallery from 'react-image-gallery';
import './index.scss';

const images = [
  {
    original: im1,
    thumbnail: im1,
  },
  {
    original: im2,
    thumbnail: im2,
  },
  {
    original: im3,
    thumbnail: im3,
  },
  {
    original: im4,
    thumbnail: im4,
  },
  {
    original: im5,
    thumbnail: im5,
  },
  {
    original: im6,
    thumbnail: im6,
  },
  {
    original: im7,
    thumbnail: im7,
  },
  {
    original: im8,
    thumbnail: im8,
  },
  {
    original: im9,
    thumbnail: im9,
  },
  {
    original: im10,
    thumbnail: im10,
  },
  {
    original: im11,
    thumbnail: im11,
  },
  {
    original: im12,
    thumbnail: im12,
  },
  ];

function Main() {
  return (
    <ProtectedRoute>
    <main className="page-layout">
    	<ImageGallery items={images} />,

      
    </main>
    </ProtectedRoute>
  );
}

export default Main;

